export default __webpack_public_path__ + "static/media/prog-html-css.07fa63bc.png";